export const dataHooks = {
    tooltip: 'status-indicator-tooltip',
};
export const STATUS = {
    ERROR: 'error',
    WARNING: 'warning',
    LOADING: 'loading',
};
export const TOOLTIP_PLACEMENT = {
    TOP: 'top',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    LEFT: 'left',
};
//# sourceMappingURL=constants.js.map